import { Component, EventEmitter, forwardRef, Input, Output, SimpleChange } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { PageOption } from "../../../models/common/pageOption";
import { Trip } from "../../../models/trips/trip";
import { TripFilter } from "../../../models/trips/tripFilter";
import { TripService } from "../../../services/trip.service";
import { ZtsiTripPickerDialogComponent } from "./ztsi-trip-picker-dialog.component";

export interface ITripPickerChange {
  tripid: number; 
  trackingId: number;
}

@Component({
  selector: "ztsi-trip-picker",
  templateUrl: "./ztsi-trip-picker.component.html",
  styleUrls: ["./ztsi-trip-picker.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ZtsiTripPickerComponent),
      multi: true,
    },
  ],
})
export class ZtsiTripPickerComponent implements ControlValueAccessor {
  isLoading: boolean = false;

  valueLabel: string = "";

  @Input() isDisabled: boolean = false;
  @Input("value") _value: number;
  @Input() clientId: number;
  @Input() trackingId: number;
  @Output() change: EventEmitter<ITripPickerChange> = new EventEmitter();

  onChange: any = () => {};
  onTouched: any = () => {};

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
    this.change.emit({
      tripid: val,
      trackingId: this.trackingId    
    });
    // if(this.change){
    //   this.change.emit(val);
    // }    
  }

  constructor(private _tripService: TripService, private _dialog: MatDialog) {}

  writeValue(value): void {    
    if (value !== undefined) {
      this._value = value;
      this.getSelected();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    if (this.value) {
      this.getSelected();
    }
  }

  getSelected() {
    this.isLoading = true;
    let filter: PageOption<TripFilter> = new PageOption();
    filter.pageNumber = 1;
    filter.pageSize = 1;
    filter.searchFilter = new TripFilter();
    filter.searchFilter.clientId = this.clientId;
    filter.searchFilter.tripId = Number(this.value);

    this._tripService.searchLimited(filter).subscribe((result) => {
      if (result.totalRecords === 1) {
        this.valueLabel = `${result.data[0].billOfLading} ${result.data[0].shippingLine}`;
      }

      this.isLoading = false;
    });
  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (changes.clientId != undefined) {
      this.clientId = changes.clientId.currentValue;
      this.getSelected();
    }
  }

  openDialog() {
    this._dialog.closeAll();
    let dialogRef = this._dialog.open(ZtsiTripPickerDialogComponent, {
      width: "80vw",
      data: {
        clientId: this.clientId,
      },
    });

    dialogRef.afterClosed().subscribe((trip: Trip) => {
      if (trip) {
        this.value = trip.id;
        this.valueLabel = `${trip.billOfLading} ${trip.shippingLine}`;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-trip-picker/ztsi-trip-picker.component.ts